import { render, staticRenderFns } from "./SideTabRight.vue?vue&type=template&id=3d44b0fa&"
import script from "./SideTabRight.vue?vue&type=script&lang=ts&"
export * from "./SideTabRight.vue?vue&type=script&lang=ts&"
import style0 from "./SideTabRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports